export default "__VITE_ASSET__b4404b69__"